module.exports = "/dist/images/76be0148f3627673bd8542e7c5347756-orderconfirm.jpg";